import React from 'react'

type Props = {
 title: string
 count: number
 color: string
}
const NetworkProfileCountCard = ({
 title,
 count,
 color,
}: Props) => {
 return (
  <>
   <div
    className={`text-[#80868C] relative rounded-lg border-[#E6EBF0] border text-xs font-normal h-[106px] pl-6 pr-4 py-3            
            `}
   >
    <div
     className={`absolute w-2 h-[51px] left-0 top-[25%] rounded-r-lg`}
     style={{backgroundColor: `${color}`}}
    ></div>
    <div className='font-medium text-2xl text-[#33393D]'>
     {count}
    </div>
    <div className='flex font-medium text-base text-[#5A6066]'>
     {title}
    </div>
   </div>
  </>
 )
}

NetworkProfileCountCard.defaultProps = {
 className: 'w-full',
}

export {NetworkProfileCountCard}
